export enum MusicMeasure {
    Beat,
    Subdivision
}